// Module
var code = `<div ng-if="charLeftController.limit > 0" class="char-left label label-{{ charLeftController.getLength() >= charLeftController.limit ? 'danger' : 'default' }}"> {{ charLeftController.limit - charLeftController.getLength() }} {{ 'Generic.LeftOver' | translate }} </div> `;
// Exports
module.exports = code;